import { render } from "./DataUsage.vue?vue&type=template&id=66362042&scoped=true"
import script from "./DataUsage.vue?vue&type=script&lang=js"
export * from "./DataUsage.vue?vue&type=script&lang=js"

import "./DataUsage.vue?vue&type=style&index=0&id=66362042&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66362042"]])

export default __exports__